module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Reportes de permisos")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudes) ? _c('div', {
    key: "lista_solicitudes",
    staticClass: "box"
  }, [_c('lista-solicitud-permisos', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudes = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaPermisos) ? _c('div', {
    key: "lista_permisos",
    staticClass: "box position-relative"
  }, [_c('lista-permisos', {
    on: {
      "close": function($event) {
        _vm.mostrarListaPermisos = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd0d0916","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Permisos_Reporte.vue
// module id = 962
// module chunks = 0